import React, {Component} from 'react';
import PropTypes from "prop-types";
import moment from 'moment';
import Api from "../../utils/Api";
import RadioBoxContainer from "../../utils/RadioBoxContainer";

class CompanyLicenceModalContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        company: PropTypes.object.isRequired,
        onSave: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {
            selectedLicence: null
        };

        this.api = new Api();

        this.translate = this.props.baseData.translate;

        this.editSelect = this.editSelect.bind(this);
        this.selectLicence = this.selectLicence.bind(this);

    }

    editSelect(event, key) {

        if (!event || key === null) return null;

        const newInput = {...this.state.inputParams};

        newInput[key] = event.value;

        this.setState({
            inputParams: newInput
        });

    }

    selectLicence(name, licence) {

        this.setState({
            selectedLicence: licence
        });

    }

    getCompanyStatus(company, atTheTime = null) {

        if (!company) return 'unknown';

        if (atTheTime === null) atTheTime = new moment().unix() * 1000;

        const timeForNewCustomer = 365 * 60 * 60 * 24 * 1000;   //  Neukunde, wenn die Firma innerhalb der letzten 365 Tage angelegt wurde und noch keine Lizenz hat.

        let companyStatus = 'noLicence';

        if (company.date_deleted !== null && company.date_deleted > 0) {
            companyStatus = 'deleted';
        } else if (company.date_licenced !== null && company.date_licenced > atTheTime) {
            companyStatus = 'active';
        } else if (company.date_licenced !== null && company.date_licenced <= atTheTime) {
            companyStatus = 'expired';
        } else if (company.date_created !== null && atTheTime - company.date_created < timeForNewCustomer) {
            companyStatus = 'newCustomer';
        }

        return companyStatus;

    }

    getLicenceOptions() {

        const companyStatus = this.getCompanyStatus(this.props.company);
        const demoLicence = {value: 'demoLicenceOneMonth', label: this.translate('demoLicenceOneMonth')};
        const initLicence = {value: 'initialLicenceOneYear', label: this.translate('initialLicenceOneYear')};
        const renewLicence1 = {value: 'renewalLicenceOneYear', label: this.translate('renewalLicenceOneYear')};
        const renewLicence2 = {value: 'renewalLicenceFiveYear', label: this.translate('renewalLicenceFiveYear')};
        const options = [];

        switch (companyStatus) {
            case 'newCustomer':
            case 'noLicence':
                options.push(demoLicence, initLicence);
                break;

            case 'active':
            case 'expired':
            case 'deleted':
                options.push(demoLicence, renewLicence1, renewLicence2);
                break;
        }

        return options;

    }

    renderSaveButton() {

        if (this.state.selectedLicence !== null) {
            return (
                <a className="prewLink" onClick={() => this.props.onSave(this.props.company, this.state.selectedLicence)}>{this.translate('add')}</a>
            );
        } else {
            return (
                <a className="prewLink disabled-link">{this.translate('add')}</a>
            );
        }

    }

    render() {

        const options = this.getLicenceOptions();
        const saveButton = this.renderSaveButton();
        const question = this.translate('whichLicenseShouldBeAdded').replace('__COMPANY__', this.props.company.name);

        return (
            <div className="clearfix">
                <nav>
                    <h1>{this.translate('addLicence')}</h1>
                </nav>

                <div className="ma-bo-10">
                    {question}
                </div>

                <div className="ma-bo-10">
                    <RadioBoxContainer
                        name="licence"
                        options={options}
                        onChange={this.selectLicence}
                    />
                </div>

                <div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={() => this.props.baseData.closeModal()}>{this.translate('cancel')}</a>

                    {saveButton}
                </div>
            </div>
        );

    }

}

export default CompanyLicenceModalContainer;